import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/">
            <img src="/images/Fintexel Logo-07.png" alt="Fintexl Logo" />
          </Link>
          <p>Excellence In Finance & Technology</p>

          {/* Social Media Links */}
          <div className="social-icons">
            <a href="https://www.instagram.com/fintexl" target="_blank" rel="noopener noreferrer">
              <img src="/images/instagram.png" alt="Instagram" />
            </a>
            <a href="https://wa.me/919603059997" target="_blank" rel="noopener noreferrer">
              <img src="/images/whatsapp-final1.png" alt="WhatsApp" />
            </a>
            <a href="https://www.youtube.com/@fintexl" target="_blank" rel="noopener noreferrer">
              <img src="/images/youtube.png" alt="YouTube" />
            </a>
            <a href="https://www.linkedin.com/company/fintexl" target="_blank" rel="noopener noreferrer">
              <img src="/images/linkedin.png" alt="LinkedIn" />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/industries">Industries</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-address">
          <h4>Our Office</h4>
          <p>Address:</p> <br />
          <p>Plot No. 92, Road No. 4. Vasanth Nagar Colony. <br />Hyderabad - 500085</p><br />
          <p>Call us now: +91 9603059997</p>
        </div>
      </div>

      <div className="footer-bottom">
       <p>&copy; 2023 FINTEXL. All Rights Reserved. Design And Developed By CalFin Team. | <Link to="/privacy">Privacy Policy</Link></p>
        <p>Powered by <a href="https://fintexl.com" target="_blank" rel="noopener noreferrer">FINTEXL Digital</a></p>
      </div>
    </footer>
  );
}

export default Footer;
